import { alas } from '@/alas';
import { Self } from '@/vue-core';
import { v4 as uuidv4 } from 'uuid';
import { defineComponent, reactive, computed, onMounted, watch } from '@vue/composition-api';
export default defineComponent({
    props: ['prop', 'value'],
    setup(props, context) {
        let self = new Self(context);
        // ================
        //
        // state
        //
        let $ = reactive({
            target: null,
            support: false
        });
        // ================
        //
        // watch
        //
        watch(() => props.value, () => {
            if ($.target !== props.value) {
                $.target = props.value;
            }
        });
        watch(() => $.target, () => {
            if ($.target !== props.value) {
                self.emit('input', $.target);
            }
        });
        // ================
        //
        // computed
        //
        let rules = computed(() => {
            let rules = [];
            if (props.prop.required) {
                rules.push('#ms.required');
            }
            if (props.prop.type === 'text') {
                rules.push('#ms.length|max:20');
            }
            if (props.prop.type === 'percentage') {
                rules.push('#ms.number');
                rules.push('#ms.range|max:100');
            }
            if (props.prop.type === 'number') {
                rules.push('#ms.number');
                rules.push('#ms.range|max:99999999');
            }
            return alas.rules(rules);
        });
        // ================
        //
        // mounted
        //
        onMounted(() => {
            $.target = props.value;
        });
        // ================
        //
        // methods
        //
        let selectProp = (support) => {
            $.target = support.value;
            $.support = false;
        };
        let getPath = () => {
            return 'props/' + uuidv4() + uuidv4() + '.jpg';
        };
        let uploadedImage = (key) => {
            $.target = key;
            self.forceUpdate();
        };
        // ================
        //
        // done
        //
        return {
            $,
            rules,
            selectProp,
            getPath,
            uploadedImage
        };
    }
});
